// extracted by mini-css-extract-plugin
export var imageBox = "image-box-module--imageBox--dg7op";